<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import VueNoty from "vuejs-noty";

export default {
  computed: {
    ...mapGetters({
      user: "getUser",
      vaults: "getVaults",
    }),
  },

  methods: {
    getVaultName(notification) {
      let vault = _.filter(this.vaults, (vault) => {
        return vault.id == notification.conversation.vault_id;
      });

      if (!_.isEmpty(vault)) {
        return vault[0].name;
      }

      return false;
    },

    getUserRole(vault_id) {
      return axios.get(`/api/vaults/${vault_id}/my-role`).then(({ data }) => {
        if (data !== "") {
          this.$store.commit("setUserRole", data);
        }
      });
    },
  },

  watch: {
    user: {
      handler(user) {
        window.Echo.private("App.User." + user.id).notification(
          (notification) => {
            if (
              notification.type ==
              "App\\Notifications\\Vault\\Discussion\\NewMessage"
            ) {
              let vault_name = this.getVaultName(notification);
              let from =
                notification.last_message.user.first_name +
                " " +
                notification.last_message.user.last_name;

              let msg = "";

              if (vault_name) {
                msg = `You received a new message from ${from}`;
              } else {
                msg = "You received a new message";
              }

              if (
                this.$route.params != undefined &&
                this.$route.params.vault_id ==
                  notification.conversation.vault_id
              ) {
                var n = this.$noty.success(msg, {
                  killer: true,
                  timeout: false,
                  closeWith: ["button", "click"],
                  buttons: [
                    Noty.button(
                      "View Message",
                      "text-white text-xs border border-white rounded p-1 mr-2",
                      () => {
                        this.$ebus.$emit(
                          "view-discussion",
                          notification.conversation
                        );
                        n.close();
                      }
                    ),
                    Noty.button(
                      "Mark as Read",
                      "text-white text-xs border border-white rounded p-1",
                      () => {
                        this.$ebus.$emit(
                          "mark-discussion-as-read",
                          notification.conversation.id
                        );
                        n.close();
                      }
                    ),
                  ],
                  callbacks: {
                    afterShow: () => {
                      this.$ebus.$emit("refresh-discussions");
                    },
                  },
                });
              } else {
                let vault_name = this.getVaultName(notification);
                let noty_btn = `Go to ${vault_name} Dashboard`;
                var n = this.$noty.success(msg, {
                  killer: true,
                  timeout: false,
                  closeWith: ["button", "click"],
                  buttons: [
                    Noty.button(
                      noty_btn,
                      "text-white text-xs border border-white rounded p-1 mr-2",
                      () => {
                        // set as current vault, get role for vault, and redirect to dashboard
                        this.$store.commit(
                          "setCurrentVault",
                          notification.conversation.vault_id
                        );

                        this.getUserRole(
                          notification.conversation.vault_id
                        ).then(() => {
                          this.$ebus.$emit(
                            "get-categorized-tags",
                            notification.conversation.vault_id
                          );

                          this.$router
                            .push({
                              name: "dashboard",
                              params: {
                                vault_id: notification.conversation.vault_id,
                              },
                            })
                            .catch((err) => {
                              if (err.name != "NavigationDuplicated") {
                                throw err;
                              }
                            });
                          n.close();
                        });
                      }
                    ),
                  ],
                });
              }

              this.$ebus.$emit("update-discussion-count");
            }
          }
        );
      },
    },
  },
};
</script>

<style>
</style>
